module.exports = __webpack_public_path__ + "static/IBN-logo-optimized-d31a20dbedb41da084f0f56e62645d8f.png";